import React from "react";
import {CTooltip} from "@coreui/react";

const ARTooltip = ({children, ...props}) => {
  return (
    <CTooltip {...props}>
      {children}
    </CTooltip>
  );
};

ARTooltip.defaultProps = {
  placement: "right-start"
};

export default ARTooltip;
